var component = require('../../../lib/js/component.js');
var productMapControllerv2 = require('../map/map-product-controller-v2.js');
var utils = require('../../../lib/js/utils.js');
var mapPinHelper = require('../map/map-pin-helper.js');
var carouselHelper = require('../../../lib/js/carousel-init-helper.js');

var ProductMapV2 = function ()
{
    var _this = this;



    var viewModel = function ()
    {
        var self = this;
        self.viewObservable = {};
    };

    var brandsInLegend = {};
    var _lotMapData = {};

    var viewLookupTable = 
    {
        "community": $(".ProductMapCommunitySidebarV2"),
        "qmi": $(".ProductMapTotalQMISidebarV2")
    };

    var _originalOrder = {};

    var _selectedCommunityID = null;
    var isQmiLoaded = false;
    this.brand = $("body").data("brand");

    var _thisInitialize;
    var _thisPMSection;
    var _isSingleQmi = false;

    this.initialize = function (el, options) 
    {
        this.$body = $('body');
        _thisInitialize = this;

        this.$ProductMapSection = this.$body != null && this.$body.length ? this.$body.find("section.ProductMapV2") : null;
        _thisPMSection = this.$ProductMapSection;

            // Create a MediaQueryList object for portrait orientation
        this.portraitMediaQuery = window.matchMedia("(orientation: portrait)");

        // Add an event listener to detect changes in orientation
        this.portraitMediaQuery.addEventListener("change", function(e) 
        {
            if (e.matches) 
            {
                // Device is now in portrait mode
                if(window.innerWidth <= 1024){
                    _this.adjustPositioningForMobile(_thisPMSection, _isSingleQmi);
                }            
            } else 
            {
                // Device is now in landscape mode
                if(window.innerWidth > 1024){
                    _this.adjustPositioningForNonMobile(_thisPMSection, _isSingleQmi);
                }
            }
        });

        _this.state = this.$element.attr("data-state");
        _this.region = this.$element.attr("data-region");
        _this.cityNames = this.$element.attr("data-cities") || this.$element.attr("data-city");
        _this.$element = this.$element;
        //store api url if it exists
        if (this.$body.data('api-url') && this.$body.data('api-url').length)
        {
            this.apiUrl = this.$body.data('api-url');
        } else {
            this.apiUrl = window.location.origin;
        }

        this.hasExperienceMessage = $('.ExperienceMessage').length ? true : false;

        // Buttons use this click with href="url" instead of data-toggle="modal" with href="#"
        $(el).find('.experience-modal-button').on('click', function (e) 
        {
            e.preventDefault();
            $('#modal-experience').modal('show', e.target);
        });

        if (!this.hasExperienceMessage) 
        {
            var $expButton = this.$element.find('.experience-modal-button');
            $expButton.attr("href", $expButton.data('href'));
            $expButton.removeAttr('data-toggle');
        }

        var $mapRef = null;
        var productMapEl = $(document).find('.ProductMapV2');
        var state = productMapEl.attr("data-state");
        var region = productMapEl.attr("data-region");
        var city = productMapEl.attr("data-city");
        var brand = $('body').data('brand');
        _lotMapData.$lotMapContainer = $(".lot-map-container");
        _this.$productMapV2panel = $(".ProductMapV2-panel");
        _this.datasource = _this.$productMapV2panel.data("datasource");

        var isMobile = window.innerWidth <= 1024
        if (isMobile)
        {
            this.adjustPositioningForMobile(this.$ProductMapSection, _isSingleQmi);      
        }
        else
        {
            this.adjustPositioningForNonMobile(this.$ProductMapSection, _isSingleQmi);
        }


        this.productLocation = 
        {
            "brand": brand,
            "flag": "",
            "pageNumber": 0,
            "pageSize": 10,
            "productType": "community",
            "qmi": false,
            "region": region,
            "state": state,
            "cityNames": city,
            "data": "",
            "searchForExact": false
        }

        if (city) 
        {
            this.productLocation.flag = "any";
            this.productLocation.data = city;
        } else if (region) 
        {
            this.productLocation.flag = "region";
            this.productLocation.data = region;
        } else 
        {
            this.productLocation.flag = "state";
            this.productLocation.data = state;
        }

        this.$thisMap = this.$element.find(".Map");
        $mapRef = this.$thisMap;

        if (this.$thisMap && this.$thisMap.length > 0) 
        {
            this.$thisMap.attach(productMapControllerv2, Pulte);
        }

        this.$thisMap.on('pinClicked', this.mapPinSelection.bind(this, $mapRef));
        this.$thisMap.on('pmap-loadMapLegend', this.loadMapLegend.bind(this));

        var $clickSelector = isMobile ? $('.ProductMapV2-panel-mobile') : $('.ProductMapV2-panel');
         // Use event delegation so all current and future .v-card elements get the click handler
        $clickSelector.off('click.vcard').on('click.vcard', '.v-card', function(e) 
        {
            _this.triggerPinSelection.call(this, $mapRef, e);
        });

        var deeplink = window.location.hash.substring(1).toLowerCase();
        var communityDeeplinkData = $('.ProductSummaryGalleryv2').data();
        var qmiDeeplinkData = $('.ProductSummaryQMIGalleryv2').data();

        var isCommunityDeeplinkMatch = communityDeeplinkData && communityDeeplinkData.deeplink && deeplink === communityDeeplinkData.deeplink.toLowerCase();
        var isQmiDeeplinkMatch = qmiDeeplinkData && qmiDeeplinkData.deeplink && deeplink === qmiDeeplinkData.deeplink.toLowerCase();

        // Invoke handleView only if deeplink is absent or does not match community and QMI deeplinks
        if (!isCommunityDeeplinkMatch && !isQmiDeeplinkMatch) 
        {
            this.handleView(null, "community");
        }

        $(window).on("resize", utils.debounce(reportWindowSize, 250, false));

        this.$element.on("pf-view-change", this.handleView.bind(this));
        this.$element.on("pfv2-filter-change", this.handleFilter.bind(this));

        var newModel = new viewModel();
        this.koModel = newModel;
        ko.applyBindings(newModel, el);
    }

    this.bindQMIEvents = function () 
    {
        $("[data-click='show-single-qmis']").off("click").on("click", this.showSingleQMIs.bind(this));
        $("[data-click='backtototal']").off("click").on("click", this.backToTotalQMIs.bind(this));
    };

    this.adjustPositioningForNonMobile = function ($section, $isSingleQmi) 
    {
        if($section && $section.length)
        {
            var $productMapV2 = $section.find(".ProductMapV2-flex");
            var $productMapV2Panel = $section.find("[productmapv2panel]");

            if ($productMapV2 && $productMapV2.length) 
            {
                if($productMapV2Panel && $productMapV2Panel.length)
                {
                    var $targetSibling = $productMapV2.find(".Map");
                    if($targetSibling && $targetSibling.length){
                        $targetSibling.after($productMapV2Panel);
                    }
                    
                    $productMapV2Panel
                            .removeClass("ProductMapV2-panel-mobile")
                            .addClass("ProductMapV2-panel");
                }

                var $vCard = $productMapV2Panel.find(".v-card");
                if($vCard && $vCard.length)
                {
                    $vCard.each(function(index)
                    {
                        var $card = $(this);

                        $card.removeClass("mobile");

                        var $vCardRow = $card.find(".v-card__row");
                        if ($vCardRow && $vCardRow.length) 
                        {
                            $vCardRow.removeClass("open");

                            var $vCardRowItem = $vCardRow.find(".v-card__row__item");
                            if ($vCardRowItem && $vCardRowItem.length && $vCardRowItem) 
                            {
                                $vCardRowItem.removeClass("v-card__row__item");
                                $vCardRowItem.find(".left-aligned").removeClass("left-aligned");
                            }
                        }
                    
                        var $productSummaryQmiInformation = $vCard.find(".product-summary-qmi-information");
                        if($productSummaryQmiInformation && $productSummaryQmiInformation.length && !$isSingleQmi)
                        {
                            if($productSummaryQmiInformation.hasClass("sm-vertical-row__item"))
                            {
                                    $productSummaryQmiInformation.removeClass("sm-vertical-row__item");
                            }
                            if($productSummaryQmiInformation.hasClass("mt-7"))
                            {
                                $productSummaryQmiInformation.removeClass("mt-7");
                            }
                        }
                    });
                }
                
                

                var $singleQmi = $section.find(".ProductMapV2-single-qmi, .ProductMapV2-single-qmi-mobile");
                var $singleQmiSidebarHeaderMobile = $section.find(".single-qmi-sidebar-header-mobile");
                var $singleQmiSidebarHeaderDesktop = $section.find(".single-qmi-sidebar-header");

                if($isSingleQmi && $singleQmi && $singleQmi.length)
                {
                    if($singleQmi.hasClass("ProductMapV2-single-qmi-mobile"))
                    {
                        $singleQmi
                        .removeClass("ProductMapV2-single-qmi-mobile")
                        .addClass("ProductMapV2-single-qmi");
                    }
                    
                    if($singleQmiSidebarHeaderMobile && $singleQmiSidebarHeaderMobile.length && 
                        $singleQmiSidebarHeaderDesktop && $singleQmiSidebarHeaderDesktop.length)
                    {
                        $singleQmiSidebarHeaderMobile.hide();
                        $singleQmiSidebarHeaderDesktop.show();
                    }

                    if($productMapV2Panel.hasClass("ProductMapV2-panel"))
                    {
                        $productMapV2Panel
                            .removeClass("ProductMapV2-panel")
                            .addClass("panel-border");
                    }

                    if(!$singleQmi.hasClass("ProductMapV2-panel"))
                    {
                        $singleQmi.addClass("ProductMapV2-panel");
                    }

                }
                else
                {
                    var $selector = $('.ProductMapV2-panel .v-card:visible');
                    $selector
                        .first()
                        .css("margin-top", "1rem");
                }
                
            }
        }
    }

    this.adjustPositioningForMobile = function($section, $isSingleQmi)
    {
        if($section && $section.length)
        {
            var $productMapV2 = $section.find("[productmapv2panel]");
            if ($productMapV2 && $productMapV2.length)
            {
                var $panelContainerProductMapV2 = $section.find(".panel-container, .mobile-panel-container");
                var $singleQmi = $section.find(".ProductMapV2-single-qmi");
                var $singleQmiSidebarHeaderMobile = $section.find(".single-qmi-sidebar-header-mobile");
                var $singleQmiSidebarHeaderDesktop = $section.find(".single-qmi-sidebar-header");
                if($panelContainerProductMapV2 && $panelContainerProductMapV2.length)
                {
                    $panelContainerProductMapV2.removeClass("panel-container");
                    $panelContainerProductMapV2.addClass("mobile-panel-container");

                    if($isSingleQmi)
                    {
                        $productMapV2
                            .removeClass("panel-border")
                            .addClass("ProductMapV2-panel-mobile");
                    }
                    $productMapV2
                        .removeClass("ProductMapV2-panel")
                        .addClass("ProductMapV2-panel-mobile");

                    $panelContainerProductMapV2.append($productMapV2);
                    var $vCard = $productMapV2.find(".v-card");
                    if($vCard && $vCard.length)
                    {
                        $vCard.each(function(index)
                        {
                            var $card = $(this);
                            if(!$card.hasClass("mobile"))
                            {
                                $card.addClass("mobile");
                            }
                            var $infoTop = $(this).find(".info__top");

                            //Info Top
                            if($infoTop && $infoTop.length)
                            {
                                var $infoTopItem = $infoTop.find(".info__top__item");
                                var $itemChild = $infoTopItem && $infoTopItem.length ? $infoTopItem.find(".item__child") : null;
                                var $infoIconContainer = $itemChild ? $itemChild.first("div") : null;
                                if($infoIconContainer)
                                {
                                    $infoIconContainer.addClass("info-icon-container");
                                }
                            }

                            var $productSummaryQmiInformation = $vCard.find(".product-summary-qmi-information");
                            if($productSummaryQmiInformation && $productSummaryQmiInformation.length && !$isSingleQmi)
                            {
                                if(!$productSummaryQmiInformation.hasClass("sm-vertical-row__item"))
                                {
                                    $productSummaryQmiInformation.addClass("sm-vertical-row__item");
                                }
                                if(!$productSummaryQmiInformation.hasClass("mt-7"))
                                {
                                    $productSummaryQmiInformation.addClass("mt-7");
                                }
                            }
                        });
                    }
                }

                if($isSingleQmi && $singleQmi && $singleQmi.length)
                {
                    // Back/Title Bar
                    if($singleQmiSidebarHeaderMobile && $singleQmiSidebarHeaderMobile.length && 
                        $singleQmiSidebarHeaderDesktop && $singleQmiSidebarHeaderDesktop.length)
                    {
                        $singleQmiSidebarHeaderDesktop.hide();
                        $singleQmiSidebarHeaderMobile.show();
                    }

                    $singleQmi.removeClass("ProductMapV2-panel");

                    // QMI Cards
                    var $vCardQmi = $singleQmi.find(".v-card");
                    if($vCardQmi && $vCardQmi.length)
                    {
                        $vCardQmi.each(function(index)
                        {
                            var $card = $(this);
                            if(!$card.hasClass("mobile"))
                            {
                                $card.addClass("mobile");
                            }
                            
                            var $verticalRow = $card.find(".sm-vertical-row");
                            var $verticalRowItem = $card.find(".sm-vertical-row__item");
                            var $vCardRow = $card.find(".v-card__row").not(".outer");
                            var $vCardRowQmiCard = $card.find(".qmi-card");
                            var $withDataPoints = $card.find(".with-datapoints");
                            var $hr = $card.find("hr");

                            if($verticalRow && $verticalRow.length && $vCard && $vCard.length && $vCardRow && $vCardRow.length)
                            { 
                                $verticalRow.append($vCardRow);
                            }
                            if($verticalRowItem && $verticalRowItem.length && 
                                $vCardRowQmiCard && $vCardRowQmiCard.length
                                && $withDataPoints && $withDataPoints.length)
                            {
                                $verticalRowItem.append($vCardRowQmiCard);
                                $verticalRowItem.append($hr);
                                $verticalRowItem.append($withDataPoints);
                                $verticalRow.append($verticalRowItem);
                            }
                        });
                    }
                }

                var $selector = $('[productmapv2panel] .v-card:visible');
                    $selector
                        .first()
                        .css("margin-top", "0");
            }
        } 
    }

    this.triggerPinSelection = function($mapRef, e) 
    {
        var eventTarget = e.target;
        var communityID = $(this).attr('data-community-id');

        if (_this.isCardSelectionEvent(eventTarget, this))
        {
            $mapRef.trigger('checkAndExpandCluster', communityID);
        }
    }

    this.isCardSelectionEvent = function (eventTarget, card)
    {
        var modalTriggers = $(card).find('[data-toggle=modal]').toArray();
        var doNotTriggerTagNames = ['a', 'button', 'path'];

        // get the parent card element that triggered the selection event
        var targetDataZone = $(eventTarget).closest('.v-card').data('analytics-zone');

        return eventTarget == card ||
            (!doNotTriggerTagNames.includes(eventTarget.tagName.toLowerCase()) &&
                !doNotTriggerTagNames.includes(eventTarget.parentElement.tagName.toLowerCase()) &&
                !eventTarget.parentElement.classList.contains('Carousel-slide') &&
                !eventTarget.classList.contains('Carousel-slide') &&
                !modalTriggers.includes(eventTarget) &&
                !modalTriggers.includes(eventTarget.parentElement)) &&
            !Object.hasOwn(eventTarget.dataset, 'dismiss') &&
            !Object.hasOwn(eventTarget.parentElement.dataset, 'dismiss') &&
            targetDataZone.toLowerCase() !== 'singleqmicard'; // clicking on a single qmi card should not scroll the map to a nearby region flag
    }

    this.showSingleQMIs = function (e) 
    {
        e.preventDefault();
        $(document).trigger("compare-view-change", 'qmi');
        
        hideAllLookupTables();

        _isSingleQmi = true;

        var $headerContainer = $(".single-qmi-sidebar-header");
        var $desktopPanel = $("[productmapv2panel]");
        var $desktopContainer = $(".ProductMapV2-single-qmi, .ProductMapV2-single-qmi-mobile");
        var $qmiCountSpans = $("[qmicount]");

        $headerContainer.show();
        $desktopContainer.show();

        var $section  = $desktopContainer.parents(".ProductMapV2");
        if($section && $section.length)
        {
            // Adjust for mobile
            if($(window).width() <= 1024)
            {
                _this.adjustPositioningForMobile($section, true);
                if($desktopContainer.hasClass("ProductMapV2-single-qmi"))
                {
                    $desktopContainer.removeClass("ProductMapV2-single-qmi");
                }

                if($desktopPanel.hasClass("panel-border"))
                {
                    $desktopPanel
                    .removeClass("panel-border")
                    .addClass("ProductMapV2-panel-mobile");
                }

                $desktopPanel.removeClass("ProductMapV2-panel").addClass("panel-border");

                if($desktopContainer.hasClass("ProductMapV2-single-qmi") || !$desktopContainer.hasClass("ProductMapV2-single-qmi-mobile"))
                {
                    $desktopContainer
                    .removeClass("ProductMapV2-single-qmi")
                    .addClass("ProductMapV2-single-qmi-mobile");
                }
                
                $desktopContainer.css("display", "flex");
                $desktopPanel.addClass("single-qmi-active");
            }
            else
            {
                // Adjust for non-mobile
                _this.adjustPositioningForNonMobile($section, true);
                
                $desktopContainer.removeClass("ProductMapV2-single-qmi-mobile");
                $desktopContainer.addClass("ProductMapV2-single-qmi");

                $desktopContainer.addClass("ProductMapV2-panel");
                
                $desktopPanel.removeClass("single-qmi-active");

                $desktopPanel
                    .removeClass("ProductMapV2-panel-mobile")
                    .addClass("panel-border");
            }
                    
        }

        var targetCommunityId = e.target.dataset.communityid;

        var $resetCommunityQMIs = $desktopContainer.find("[data-communityid]:not([data-communityid='" + targetCommunityId + "'])");
        $resetCommunityQMIs.hide();

        setCommunityData(e);
        var $communityQMIs = $desktopContainer.find("[data-communityid='" + targetCommunityId + "']");
        $communityQMIs.show();

        $qmiCountSpans.text($communityQMIs.length);

        if (!this.hasExperienceMessage) {
            var $sidebarButton = this.$element.find('.experience-modal-button-sidebar');
            $sidebarButton.attr("href", $sidebarButton.data('href'));
            $sidebarButton.removeAttr('data-toggle');
        }

        this.showLotMap(targetCommunityId);
    };

    this.backToTotalQMIs = function (e) 
    {
        this.handleView.call(this, e, "qmi");
        this.hideLotMap();
    };

    this.hideQMISidebar = function () 
    {
        // hide card container and header container
        $(".ProductMapV2-single-qmi, .single-qmi-sidebar-header").hide();

        $("[productmapv2panel]").addClass("ProductMapV2-panel").removeClass("panel-border");
        $(".ProductMapV2-panel").removeClass("single-qmi-active");
        $(".ProductMapV2-single-qmi").removeClass("ProductMapV2-panel");
    };

    this.resetPinSelection = function (e) 
    {
        e.preventDefault();
        this.$thisMap.trigger('resetPinSelection');
    };

    this.formatProductType = function (productType) 
    {
        return productType.replaceAll(/[.:()-\s]/g, "").toLowerCase();
    };

    this.handleView = function (event, view, filterValues) 
    {
        var formattedProductType = this.formatProductType(view);
        this.updateMapPins(event, formattedProductType, filterValues);

        // this is to center align the No QMI Available message at the SM and XS breakpoints
        if ($('.ProductMapV2').data('qmiCount') == 0 && formattedProductType == 'qmi' && $(window).width() <= 1024) 
        {
            $('.ProductMapV2-panel').addClass('d-none');
        } else 
        {
            $('.ProductMapV2-panel').removeClass('d-none');
        }

        hideAllLookupTables();
        this.hideQMISidebar();
        this.hideLotMap();

        Object.values(viewLookupTable).forEach(function (val) 
        {
            val.hide()
        });
        viewLookupTable[view].show();

        if (formattedProductType === "qmi") 
        {
            if (!isQmiLoaded) 
            {
                isQmiLoaded = true;
                _this.loadQmiGallery();
                _this.loadQmiSidebar();
            }
        } 

        var $locationCopySubheader = $('.LocationCopyCard');
        var $communityLocationCopy = $locationCopySubheader.find('.LocationCopyCard__subHeader[data-copy-type="community"]');
        var $qmiLocationCopy = $locationCopySubheader.find('.LocationCopyCard__subHeader[data-copy-type="qmi"');
        if ($locationCopySubheader.length) 
        {
            if (view == 'community') 
            {
                $($communityLocationCopy[0]).show();
                $($qmiLocationCopy[0]).hide();
            } else {
                $($communityLocationCopy[0]).hide();
                $($qmiLocationCopy[0]).show();
            }
        }
    };

    this.loadQmiGallery = function () {
        $(".ProductSummaryQMIGalleryv2")
            .html('<div id="qmi-loading-placeholder" class="text-center py-5">Loading Quick Move-In Homes....</div>')
            .show();
        $.ajax({
            context: _this,
            type: "GET",
            url:
                "/api/Sitecore/Products/LoadQmiSummary?" + "brandName=" + _this.brand + "&state=" + _this.state + "&region=" + _this.region + "&cityNames=" + _this.cityNames + "&datasource=" + _this.datasource,
            success: function (html) {
                var $qmiGallery = $(".ProductSummaryQMIGalleryv2");
                $qmiGallery.html(html).show();
                carouselHelper.initializeCarouselsAndCloudinary($qmiGallery);
                // Scroll to first QMI card after content is loaded
                scrollToFirstQmiCard();
            },
            error: function () {
                $(".ProductSummaryQMIGalleryv2")
                    .html(
                        '<div class="text-danger text-center py-5">Failed to load Quick Move-In homes.</div>'
                    )
                    .show();
            }
        });
    };

    this.loadQmiSidebar = function () 
    {
        var _this = this;
       var $loadingPlaceholder = $('<div id="qmi-loading-placeholder" class="text-center py-5">Loading Quick Move-In Homes....</div>');
        _this.$productMapV2panel.append($loadingPlaceholder).show();
        $.ajax(
        {
            type: "GET",
            url: "/api/Sitecore/Maps/LoadQmiSidebar",
            data: 
            {
                state: _this.state,
                region: _this.region,
                cityNames: _this.cityNames,
                datasource: _this.datasource
            },
            success: function (html) 
            {
                $loadingPlaceholder.remove();
                _this.$productMapV2panel.append(html);
                carouselHelper.initializeCarouselsAndCloudinary(_this.$productMapV2panel);
                _this.$productMapV2panel.find(".single-qmi-sidebar-header").hide();
                _this.$productMapV2panel.find(".ProductMapV2-single-qmi").hide();
                viewLookupTable["qmi"] = $(".ProductMapTotalQMISidebarV2");
                _this.bindQMIEvents.bind(_thisInitialize)();
                if(window.innerWidth <= 1024)
                {
                    _this.adjustPositioningForMobile(_thisPMSection, false);
                }
                else
                {
                    _this.adjustPositioningForNonMobile(_thisPMSection, false);
                }
            },
            error: function () 
            {
                $loadingPlaceholder.remove();
                _this.$productMapV2panel.append(
                    '<div class="text-danger text-center py-5">Failed to load QMI sidebar.</div>'
                );
            }
        });
    };


    this.handleFilter = function (event, searchResult, filterValues, isFiltered, productType) 
    {
        var resetOrder = !isFiltered;
        var formattedProductType = this.formatProductType(productType);

        this.updateMapPins(event, formattedProductType, filterValues);

        // order sidebar cards
        if (formattedProductType === "communities") 
        {
            orderSidebarCardsByCommunityId(".ProductMapCommunitySidebarV2", searchResult, resetOrder);
        } else if (formattedProductType === "quickmoveins") 
        {
            orderSidebarCardsByCommunityId(".ProductMapTotalQMISidebarV2", searchResult, resetOrder);
            orderSingleQMICards(".ProductMapV2-single-qmi", searchResult, resetOrder);
        }
    }

    this.updateMapPins = function (event, productType, filterValues) 
    {
        var mapPinsFilters = {};
        mapPinsFilters.productType = productType;
        mapPinsFilters.brand = this.productLocation.brand;
        mapPinsFilters.state = this.productLocation.state;
        mapPinsFilters.region = this.productLocation.region;
        mapPinsFilters.cityNames = this.productLocation.cityNames;

        mapPinsFilters.qmi = productType === 'qmi' || productType === 'quickmoveins';

        if (event != null)
            this.resetPinSelection(event);

        if (filterValues) 
        {
            mapPinsFilters.minPrice = filterValues['PR Lower'];
            mapPinsFilters.maxPrice = filterValues['PR Upper'];
            mapPinsFilters.minBedrooms = filterValues['Bedrooms'];
            mapPinsFilters.minBathrooms = filterValues['Bathrooms'];

            filterValues['Home Options'].forEach(function (type) 
            {
                mapPinsFilters[type] = true;
            }.bind(this));
        }

        this.$thisMap.trigger('filterSelected', mapPinsFilters);
    }

    function orderSidebarCardsByCommunityId(selector, searchResult, resetOrder) 
    {
        // orders community cards by community search, or total qmi cards by qmi search

        var originalOrderKey = selector.replaceAll(/[.:()-]/g, "");
        if (resetOrder && _originalOrder[originalOrderKey])
            searchResult = _originalOrder[originalOrderKey];

        if (!searchResult) return;

        var communityIds = searchResult.map(function (item) { return item.communityId || item.id });
        var distinctCommunityIds = Array.from(new Set(communityIds));

        var $targetCards = $(selector);
        var $prev = $targetCards.first().prev();
        var $parent = $targetCards.first().parent();

        if (!_originalOrder[originalOrderKey]) 
        {
            _originalOrder[originalOrderKey] = $targetCards.map(function (i, card) 
            {
                var cardData = $(card).data();
                return { communityId: cardData.communityId || cardData.id }
            }).toArray();
        }

        $targetCards.detach();
        var orderedElements = [];
        distinctCommunityIds.forEach(function (id) 
        {
            var matchingTotalQMICard = $targetCards.filter('[data-community-id="' + id + '"]')[0];
            if (matchingTotalQMICard)
                orderedElements.push(matchingTotalQMICard);
        });

        if ($prev.length > 0)
            $(orderedElements).insertAfter($prev);
        else
            $parent.prepend(orderedElements);
    }

    function orderSingleQMICards(selector, filteredQMIs, resetOrder) 
    {
        var originalOrderKey = selector.replaceAll(/[.:()-]/g, "");
        if (resetOrder && _originalOrder[originalOrderKey])
            filteredQMIs = _originalOrder[originalOrderKey];

        if (!filteredQMIs) return;

        var lotNumbers = filteredQMIs.map(function (qmi) { return qmi.lotBlock });

        var $container = $(selector);
        var $singleQMICards = $container.children();

        if (!_originalOrder[originalOrderKey]) 
        {
            _originalOrder[originalOrderKey] = $singleQMICards.map(function (i, card) 
            {
                var cardData = $(card).data();
                return { lotBlock: cardData.lotNumber }
            }).toArray();
        }

        $singleQMICards.detach();
        var orderedElements = [];
        lotNumbers.forEach(function (number) 
        {
            var matchingSingleQMICard = $singleQMICards.filter('[data-lot-number="' + number + '"]')[0];
            orderedElements.push(matchingSingleQMICard);
        });

        $container.prepend(orderedElements);
    }

    this.updateMapResults = function (e) 
    {
        this.resetPinSelection(e);

        // the location is determined in the map-product-controller-v2
        this.$thisMap.trigger('filterSelected', this.productLocation);
    }

    // this fires many times on page load, added debounce in above init, real fix will be when carousel v2 stops triggering many window resize events on load. 
    function reportWindowSize() 
    { 
        $('[productmapv2panel]').animate({ scrollTop: 0 }, 100);
        setCardScrollValues();
        if (_selectedCommunityID != null) 
        {
            highlightCardByCommunityID(_selectedCommunityID);
        }
    }

    function highlightCardByCommunityID(communityID) 
    {
        var $productPanel = $("[productmapv2panel]");

        var $allActiveCards = $productPanel.find('.v-card.active');
        $allActiveCards.removeClass('active');

        var totalQMIVCard = $productPanel.find(".ProductMapTotalQMISidebarV2.v-card[data-community-id='" + communityID + "'], .ProductMapTotalQMISidebarV2.v-card-mobile[data-community-id='" + communityID + "']");
        var totalQMIShowing = ($('.ProductMapTotalQMISidebarV2').css('display') !== 'none') && totalQMIVCard.length !== 0;   
        var communityVCard = $productPanel.find(".ProductMapCommunitySidebarV2.v-card[data-community-id='" + communityID + "'], .ProductMapCommunitySidebarV2.v-card-mobile[data-community-id='" + communityID + "']");

        var $selectedCard = totalQMIShowing ? totalQMIVCard : communityVCard;

        if ($selectedCard) 
        {
            _selectedCommunityID = communityID;
            var currentWindowWidthDifference = $(window).width() - $selectedCard.width();
            var widthOffset = currentWindowWidthDifference / 2;

            $selectedCard.addClass('active');
            var scrollOffset = 0;
            var panelTop = $("[productmapv2panel]").offset().top;
            var positionTop = $selectedCard.attr('data-top') ? $selectedCard.attr('data-top') : 0;
            var positionLeft = $selectedCard.attr('data-left') ? $selectedCard.attr('data-left') : 0;
            var scrollPosition = $(document).scrollTop();
            var $productFilter = $('#ProductFilterV2');
            var stickyHeaderOffset = 0;

            if ($('.GlobalHeaderV2').hasClass('is-showing')) 
            {
                stickyHeaderOffset = $('.GlobalHeaderV2').height();
            }

            if ($productFilter.hasClass('affix')) 
            {
                stickyHeaderOffset = $productFilter.height();
            }

            if ((scrollPosition + stickyHeaderOffset) > panelTop) 
            {
                scrollOffset = ((scrollPosition - panelTop) + stickyHeaderOffset);
            }

            var isMobile = window.innerWidth < 1025;
            if (isMobile) 
            {
                $productPanel.animate({ scrollLeft: positionLeft - widthOffset }, 0);
            }
            else 
            {
                $productPanel.animate({ scrollTop: positionTop - scrollOffset }, 0);
            }
        }
    }

    function highlightFirstCard() 
    {
        setCardScrollValues();
        var isMobile = window.innerWidth < 1025;
        var $panel = $('[productmapv2panel]');
        var $selector = $panel.find('.v-card:visible');
        $selector
            .first()
            .trigger("click", { fromApply: true });
        // Include a custom flag to indicate this click originates from 'Apply and Reset'  
        if(!isMobile)
        {
            $selector
                .first()
                .css("margin-top", "1rem");
        }  
    }

    function setCardScrollValues() 
    {
        var isMobile = window.innerWidth < 1025;
        var $scrollContainer = $('[productmapv2panel]');

        if (isMobile) 
        {
            $scrollContainer.animate({ scrollLeft: 0 }, 100);
            $scrollContainer.find('.v-card:visible').each(function (_, card) 
            {
                $(card).attr('data-left', card.getBoundingClientRect().left + $scrollContainer.scrollLeft());
            });
        } else 
        {
            $scrollContainer.animate({ scrollTop: 0 }, 100);
            $scrollContainer.find('.v-card:visible').each(function (_, card) {
                var cardTop = card.getBoundingClientRect().top;
                var containerTop = $scrollContainer[0].getBoundingClientRect().top;
                var calculatedTop = cardTop - containerTop;
                $(card).attr('data-top', calculatedTop + $scrollContainer.scrollTop());
            });
        }
    }

    function scrollToFirstQmiCard() 
    {
        var $scrollToElement = $(".ProductSummaryQMIGalleryv2 .QMIGalleryCard:visible, .ProductSummaryQMIGalleryv2 .QMIGridCard:visible").first();
        var offset = 0;
        var $filterElement = $("#ProductFilterV2:visible");

        if ($filterElement && $filterElement.length) 
        {
            offset = $filterElement.height();
        }

        var mapGalleryToggleVm = ko.dataFor(document.getElementById("product-map-gallery-toggle"));

        // on First load scroll Only if gallery is selected (not map)
        if ($scrollToElement && $scrollToElement.length && mapGalleryToggleVm && mapGalleryToggleVm.toggleMapGallerySelect && !mapGalleryToggleVm.toggleMapGallerySelect.map()) 
        {
            $("html, body").animate({
                scrollTop: $scrollToElement.offset().top - offset
            }, 1000);
        }
    }

//setting map pin icon for legend
    this.setMapPinIcon = function ($element, iconSvgProperties) 
    {
        iconSvgProperties.scale = 0.75;

        var mapPinProperties = mapPinHelper.getGoogleMapPinObject(iconSvgProperties);
        // Ensure $element is an <img> tag
        if ($element.is('img')) 
        {
            // Set attributes safely
            $element.attr(
            {
                src: mapPinProperties.url,
                width: mapPinProperties.scaledSize.width,
                height: mapPinProperties.scaledSize.height,
                alt: 'Map Pin Icon'
            });

            // Optional: force re-render in case browser doesn't update immediately
            $element[0].src = mapPinProperties.url;
        } 
    };

    // Ensure the legend is closed by default on mobile/tablet and open on desktop
    if (utils.is.mobileOrTabletScreen()) 
    {
        $('.legend-container').removeClass('open'); 
    } 
    else 
    {
        $('.legend-container').addClass('open'); 
    }

    $('.legend-container > .header-row').on('click', function () 
    {
        var $legendContainer = $('.legend-container');
        if ($legendContainer.hasClass('open')) 
        {
            $legendContainer.removeClass('open');

            // Ensure rows with icons remain visible
            $legendContainer.find('tr').each(function () 
            {
                var $row = $(this);
                if ($row.find('img').length > 0) 
                {
                    $row.css('display', 'table-row');
                }
            });
        } else 
        {
            $legendContainer.addClass('open');
        }
    });

    this.loadMapLegend = function (e, brandsInSearch) 
    {
        brandsInLegend = {};

        var brandConfigs = 
        {
            pulte: { brandName: 'Pulte' },
            pulteActiveAdult: { brandName: 'Pulte', isActiveAdult: true },
            centex: { brandName: 'Centex' },
            delwebb: { brandName: 'DelWebb',  isExplore: false },
            delwebbExplore: { brandName: 'DelWebb', isExplore: true },
            divosta: { brandName: 'DiVosta' },
            jw: { brandName: 'JW' },
            americanwest: { brandName: 'AmericanWest' }
        };

        function setPinIcons(key, config) 
        {
            var exactSelector = '.ProductMap__' + key + 'Exact';
            var closeSelector = '.ProductMap__' + key + 'Close';

            var exactOptions = 
            {
                brandName: config.brandName,
                pinType: 'exact',
                isDWExplore: config.isExplore || false
            };
            var closeOptions = 
            {
                brandName: config.brandName,
                pinType: 'close',
                isDWExplore: config.isExplore || false
            };

            if (config.isActiveAdult) 
            {
                exactOptions.isActiveAdult = true;
                closeOptions.isActiveAdult = true;
            }
            if (config.isExplore) 
            {
                exactOptions.isExplore = true;
                closeOptions.isExplore = true;
            }

            this.setMapPinIcon(this.$element.find(exactSelector), exactOptions);
            this.setMapPinIcon(this.$element.find(closeSelector), closeOptions);
        }

        var boundSetPinIcons = setPinIcons.bind(this);

        for (var key in brandsInSearch) 
        {
            if (!brandsInSearch.hasOwnProperty(key)) continue;

            var isVisible = brandsInSearch[key];
            var config = brandConfigs.hasOwnProperty(key) ? brandConfigs[key] : { brandName: key };
            var $row = this.$element.find('.ProductMap__' + key);

            if ($row.length) 
            {
                if (isVisible) 
                {
                    $row.removeClass('d-none').show();
                    boundSetPinIcons(key, config);
                    brandsInLegend[key] = true;
                } else 
                {
                    $row.addClass('d-none').hide();
                }
            } 
        }
    };

    this.lotClickedAndScroll = function (lotID) 
    {
        var $productPanel = $('.ProductMapV2-panel');
        var isMobile = window.innerWidth < 1025;

        var $allActiveCards = $productPanel.find('.v-card.active');
        $allActiveCards.removeClass('active');

        var $selectedCard = $productPanel.find("[data-lot-number='" + lotID + "']");
        if ($selectedCard.length) 
        {
            $selectedCard.addClass('active');

            if (isMobile) 
            {
                var $singleQmi = $('.ProductMapV2-single-qmi');
                $singleQmi.animate({ scrollLeft: $selectedCard.position().left + $singleQmi.scrollLeft() }, 0);
            }
            else 
            {
                var scrollOffset = $productPanel.offset().top;
                $productPanel.animate({ scrollTop: $selectedCard.position().top + $productPanel.scrollTop() - scrollOffset }, 0);
            }
        }
    };

    this.mapPinSelection = function ($mapRef, e, product) 
    {
        var $singleQmiContainer = $(".ProductMapV2-single-qmi:visible");

        if ($singleQmiContainer.length) 
        {
            this.hideQMISidebar();
            $(".ProductMapTotalQMISidebarV2").show();
        }
        setCardScrollValues();
        highlightCardByCommunityID(product.communityId);
        $mapRef.trigger('updateCommunityID', product.communityId);

    };

    function hideAllLookupTables() 
    {
        Object.values(viewLookupTable).forEach(function (val) 
        {
            val.hide()
        });
    }

    //sets community data in the sidebar including DW Explore logo for 
    function setCommunityData(e) 
    {
        var dataset = e.target.dataset;

        var $communityBannerImageContainer = $(".community-banner-image-container");
        $communityBannerImageContainer.find("svg").remove();
        $communityBannerImageContainer.append(dataset.communityBannerLogo);
        var $communityNameHeadline = $(".ProductSummary__headline[communityname]");
        var $anchorCommunityNameTag = $('<a> </a>');
        $anchorCommunityNameTag.attr(
            {
                "href": "#",
                "class": "experience-modal-button-sidebar",
                "data-target": "#modal-experience",
                "target": "_blank",
                "rel": "noopener",
                "data-toggle": "modal",
                "data-is-active-adult": dataset.isActiveAdult,
                "data-target-brand": dataset.targetBrand,
                "data-href": dataset.href
            }
        ).html(dataset.communityName);

        $communityNameHeadline.empty();
        $communityNameHeadline.append($anchorCommunityNameTag);
    }

    this.showLotMap = function (targetCommunityId) 
    {
        var enableLotMap = _lotMapData.$lotMapContainer[0].getAttribute("data-enable-lot-map").toLowerCase() === "true";

        if (!enableLotMap) return;

        this.setupAlphaVisionApi.call(this, targetCommunityId);
    }

    this.hideLotMap = function () 
    {
        $(".Map-container").show();
        _lotMapData.$lotMapContainer.hide().html("");
        _lotMapData.isLotMapVisible = false;
        _lotMapData.hasQMI = false;
        _lotMapData.isReady = false;
    }

    this.setupAlphaVisionApi = function (targetCommunityId) 
    {
        var lotMapContainer = _lotMapData.$lotMapContainer[0];
        this.mapApi = new AVSiteplan(lotMapContainer.getAttribute("data-builder-guid"),
            targetCommunityId,
            lotMapContainer,
            this.genericCallback.bind(this),
            this.eventCallback.bind(this)
        );
    }

    this.eventCallback = function (response) 
    {
        this.selectQMILot(response.data.lotGroupName, response.data.lotLabel);
        this.lotClickedAndScroll(response.data.lot);
    }

    this.genericCallback = function (response) 
    {
        if (response.datatype.toLowerCase() == "mastermap") 
        {
            this.setSitePlanAndLot.call(this);

            if (!_lotMapData.hasQMI) return;

            this.mapApi.selectMap(_lotMapData.sitePlan);
            this.showLotMapOnSuccess();
        }
        else if (response.datatype.toLowerCase() == "siteplan") 
        {
            this.setSitePlanAndLot.call(this);

            if (!_lotMapData.hasQMI) return;

            var lotArray = this.mapApi.filterLots("Quick Move In").lots;
            for (var i = 0; i < lotArray.length; i++) 
            {
                $("#g" + lotArray[i].lotGroupName + "_l" + lotArray[i].lotNumber).addClass("qmis-lots");
            }

            this.selectQMILot(_lotMapData.groupNumber, _lotMapData.lotLabel);
            this.lotClickedAndScroll(_lotMapData.lotNumber);
            this.showLotMapOnSuccess();
        }
    }

    this.setSitePlanAndLot = function () 
    {
        if (_lotMapData.isReady) return;

        var $qmiCard = $("[qmicontainer]").find(".v-card:visible:first");
        var firstCardLotNumber = $qmiCard.data().lotNumber;

        _lotMapData.hasQMI = this.mapApi.alphamapApiResult.Siteplans.some(function (sitePlan) 
        {
            return sitePlan.LotDetails.some(function (singleLot) 
            {
                return singleLot.status === "Quick Move In";
            });
        });

        if (!_lotMapData.hasQMI) return;

        this.mapApi.alphamapApiResult.Siteplans.some(function (sitePlan) 
        {
            // set first site plan in case no lot matches
            if (!_lotMapData.sitePlan) _lotMapData.sitePlan = sitePlan.SiteplanName;

            return sitePlan.LotDetails.some(function (singleLot) 
            {
                if (singleLot.Lot == firstCardLotNumber) 
                {
                    _lotMapData.groupNumber = singleLot.LotGroupName;
                    _lotMapData.lotLabel = singleLot.LotLabel;
                    _lotMapData.lotNumber = firstCardLotNumber;
                    _lotMapData.sitePlan = sitePlan.SiteplanName;
                    return true;
                }
            });
        });

        _lotMapData.isReady = true;
    };

    this.showLotMapOnSuccess = function () 
    {
        if (!_lotMapData.isLotMapVisible) 
        {
            $(".Map-container").hide();
            _lotMapData.$lotMapContainer.css("display", "grid");
            _lotMapData.isLotMapVisible = true;
        }
    };

    this.selectQMILot = function (groupNumber, lotNumber) 
    {
        var LotClickedId = "g" + groupNumber + "_l" + lotNumber;
        $(".lotPolygon").removeAttr("style");
        var lotMapContainer = _lotMapData.$lotMapContainer[0];
        var brandColor = lotMapContainer.getAttribute("data-highlight-color");
        $("#" + LotClickedId).css("fill", brandColor);
    }
};

module.exports = component(ProductMapV2);
